.zone {
  --active-zone-edge-inline-inset: 12px;
  --active-zone-inline-inset: 12px;
  --active-zone-block-inset: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 64px;
  padding: var(--active-zone-block-inset) var(--active-zone-inline-inset);
  margin: calc(var(--active-zone-block-inset) * -1) calc(var(--active-zone-inline-inset) * -1);
  flex-shrink: 0;
  z-index: 1;
  cursor: pointer;
}

/* Edge zones should stretch to the control panel bounds. */
.zone[data-testid='active-zone-play'] {
  margin-inline-start: calc(var(--active-zone-edge-inline-inset) * -1);
}

.zone[data-testid='active-zone-fullscreen'] {
  margin-inline-end: calc(var(--active-zone-edge-inline-inset) * -1);
}

@container (max-width: 480px) {
  .zone {
    --active-zone-inline-inset: 4px;
    --active-zone-block-inset: 12px;
  }
}

@container (max-width: 320px) {
  .zone {
    --active-zone-inline-inset: 4px;
    --active-zone-block-inset: 12px;
  }
}

@container (max-height: 379px) {
  .zone {
    --active-zone-edge-inline-inset: 16px;
  }
}

/* Forward hover to nested buttons when the user hovers zone padding. */
.zone:hover button:not([disabled]):not([data-active-zone-exclude='true'] *) {
  background-color: rgba(49, 75, 153, 0.5);
  color: #fff;
}

/* Forward hover to volume wrapper, which owns slider hover behavior. */
.zone:hover [data-volume-control] {
  background-color: rgba(49, 75, 153, 0.5);
}

.zone:hover [data-volume-control] [data-volume-slider] {
  display: flex;
}

/* Volume control draws a shared hover pill itself in horizontal mode,
   so do not paint an extra button background for its mute button. */
.zone:hover [data-volume-control] button:not([disabled]):not([data-active-zone-exclude='true'] *) {
  background-color: transparent;
}

@container (max-width: 675px) {
  .zone:hover [data-volume-control] {
    background-color: transparent;
  }

  .zone:hover [data-volume-control]::before {
    opacity: 1;
  }
}

/* Collapse empty zones — PluginSlot renders a fragment so an unpopulated slot
   leaves this div truly empty; hiding it removes all padding/margin gaps. */
.zone:empty {
  display: none;
}

@container (min-width: 676px) {
  .zone {
    min-height: 68px;
  }
}
